import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { ChartComponentProps, getBaseOption, FALLBACK_PALETTE, ECHARTS_OPTS, getCategoryValue, toNumericValue } from './chartConfig';

export const GaugeChart: React.FC<ChartComponentProps> = ({ chart, height = 320, colors }) => {
  const option = useMemo((): EChartsOption => {
    const data = chart.data || [];
    if (data.length === 0) return {};

    const base = getBaseOption(colors);
    const palette = colors && colors.length > 0 ? colors : FALLBACK_PALETTE;

    const gaugeData = data.slice(0, 4).map((d, i) => ({
      name: getCategoryValue(d),
      value: toNumericValue(d.value),
      title: { offsetCenter: ['0%', `${70 + i * 20}%`] },
      detail: { offsetCenter: ['0%', `${85 + i * 20}%`] },
      itemStyle: { color: palette[i % palette.length] },
    }));

    const maxVal = Math.max(...gaugeData.map(d => d.value), 100);

    return {
      ...base,
      series: [
        {
          type: 'gauge',
          startAngle: 210,
          endAngle: -30,
          min: 0,
          max: maxVal,
          pointer: { show: true, length: '60%', width: 6 },
          axisLine: {
            lineStyle: {
              width: 20,
              color: [
                [0.3, '#3F7D4F'],
                [0.7, '#C9A24E'],
                [1, '#B23A48'],
              ],
            },
          },
          axisTick: { length: 6, lineStyle: { color: 'auto' } },
          splitLine: { length: 14, lineStyle: { color: 'auto', width: 2 } },
          axisLabel: { fontSize: 10, color: '#7B6B72', distance: 25 },
          detail: { fontSize: 14, color: '#1F1A20', offsetCenter: [0, '70%'] },
          title: { fontSize: 12, offsetCenter: [0, '90%'], color: '#7B6B72' },
          data: gaugeData.length === 1 ? gaugeData : gaugeData.slice(0, 1),
        },
      ],
      tooltip: { show: false },
    };
  }, [chart, colors]);

  return <ReactECharts option={option} style={{ height }} notMerge lazyUpdate opts={ECHARTS_OPTS} />;
};
